
import { CompoundProductionStepAssignmentDto, CreateCompoundProductionStepAssignmentDto, UpdateCompoundProductionStepAssignmentDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { compoundProductionStepAssignmentService, CompoundProductionStepAssignmentsFilters } from '@services/CompoundProductionStepAssignmentService'

const { reducer, actions, thunks } = baseCrudReducer<
  CompoundProductionStepAssignmentDto,
  CreateCompoundProductionStepAssignmentDto,
  UpdateCompoundProductionStepAssignmentDto,
  CompoundProductionStepAssignmentsFilters
>('compoundProductionStepAssignment', compoundProductionStepAssignmentService)

export default reducer

export const { setFilters: setCompoundProductionStepAssignmentFilters } = actions

export const {
  getAll: getCompoundProductionStepAssignments,
  create: createCompoundProductionStepAssignment,
  update: updateCompoundProductionStepAssignment,
  remove: removeCompoundProductionStepAssignment,
} = thunks
